exports.default = {
  'copy_code': '複製代碼',
  'copy_success': '複製成功！',
  'copy_failed': '複製失敗！',
  'image_save_success': '圖片保存成功',
  'image_save_failed': '圖片保存失敗',
  'file_created': '文件已創建',
  'file_creating': '正在創建文件',
  'file_creation_stopped': '文件創建已停止',
  'action_finished': '操作已完成',
  'action_executing': '正在執行操作',
  'action_stopped': '操作已停止',
  'completed': '完成',
  'in_progress': '進行中',
  'stopped': '已停止'
}
